import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StartInterviewContainer } from './components/start-interview/start-interview.container';
import { SurveyInterviewContainer } from './components/survey-interview/survey-interview.container';
import { SurveyNavigation } from './constants/surveys.constants';
import { SurveyStartActivator } from './guards/survey-start.activator';
import { SurveyActivator } from './guards/survey.activator';

const routes: Routes = [
    {
        path: '',
        canActivate: [SurveyActivator],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: SurveyNavigation.Start,
            },
            {
                path: SurveyNavigation.SurveyStep,
                component: SurveyInterviewContainer,
            },
            {
                path: SurveyNavigation.Start,
                canActivate: [SurveyStartActivator],
                component: StartInterviewContainer,
            },
            {
                path: '**',
                redirectTo: SurveyNavigation.Start,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class SurveyRoutingModule {}
